import MotifAccordionContent from '@ey/motif-react-wrapper/AccordionContent.js';
import styled from 'styled-components';

export default styled(MotifAccordionContent)`
	padding: unset !important;
	width: 100%;
	max-height: var(--px-450);
`;
